import CardTable from 'components/CardTable/CardTable'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AddIcon from "@material-ui/icons/Add";
import { useRevalidateFetch } from "hooks/useRevalidateFetch";
import { columns } from './columns'
import {
  setComoDataTanksFilters,
  resetComoDataTankSelected,
  addComoDataTankMode,
  getComoDataTank,
  getBrandTanks,
  clearComoDataTanks,
} from 'redux/actions/comoDataTanks/comoDataTanksActions'
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import RegularButton from 'components/CustomButtons/Button'
import { useSearch } from 'hooks/useSearch'
import { ModalV2 } from 'components/Modal/ModalV2'
import { FormComoDataTankEdit } from './FormComoDataTankEdit'
import { TableInputs } from "components/CardTable/TableInputs";

const tableKey = "comoDataTanks";

export const ComoDataTanks = () => {
  const { setSnackbar, buildCompLoadings } = useSearch();
  const { station, comoDataTanksArr, addMode, brandsTank } = useSelector(state => state.comoDataTanks)
  const { isLoadingComp } = useSelector((state) => state.search);
  const [mapComoDataTanks, setComoDataTanks] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()


  const handleSubmit = (e) => {
    e.preventDefault()
    if (station?.length === 0) {
      setSnackbar("Falta seleccionar planta")
      return
    }
    dispatch(getComoDataTank(station.id))
  };

  const handleClose = () => {
    dispatch(resetComoDataTankSelected())
    setIsOpen(false)
  }

  const handleOpenAdd = () => {
    dispatch(addComoDataTankMode())
    setIsOpen(true)
  }

  useRevalidateFetch(getBrandTanks, brandsTank);
  // Effects
  useEffect(() => {
    if (brandsTank?.length > 0) {
      setComoDataTanks(
        comoDataTanksArr?.map(comoDataTank => {
          return {
            ...comoDataTank,
            modal: setIsOpen,
          }
        }).flat()
      )
    }
  }, [comoDataTanksArr, brandsTank])

  useEffect(() => {
    const isEmpty = mapComoDataTanks.length === 0
    if (isEmpty && submitted) {
      setSnackbar("No se encontraron tanques");
    }
    setSubmitted(false);
    // eslint-disable-next-line
  }, [mapComoDataTanks])

  useEffect(() => {
    buildCompLoadings(["loadingComoDataTanks"]);
  }, []);

  useEffect(() => {
    return () => dispatch(clearComoDataTanks())
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <CardTable
        data={mapComoDataTanks}
        columns={columns}
        isLoading={isLoadingComp?.loadingComoDataTanks}
        blockBtn
        tableKey={tableKey}
        hasHeader
        icon={<PropaneTankIcon />}
        title="Tanques Comodatos"
        tableContent={
          <TableInputs
            reducer="comoDataTanks"
            stations
            dispatchAction={setComoDataTanksFilters}
            submitAction={handleSubmit}
          />
        }
        hasControl
        controls={
          <RegularButton round justIcon color="info" onClick={handleOpenAdd}>
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      <ModalV2
        open={isOpen}
        title={
          addMode
            ? 'Agregar tanque'
            : 'Modificar tanque'
        }
        toRight
        onClose={handleClose}
        style={{
          'div': {
            border: '5px solid red', margin: 50
          }
        }}
      >
        <FormComoDataTankEdit handleClose={handleClose} />
      </ModalV2>
    </React.Fragment>
  )
}
